import constants from "./constants";
import FeedIcon from "@mui/icons-material/Feed";
import DashboardIcon from "@mui/icons-material/Dashboard";
import WorkHistoryIcon from "@mui/icons-material/WorkHistory";
import SearchIcon from "@mui/icons-material/Search";
import CreateIcon from "@mui/icons-material/Create";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import DynamicFeedIcon from "@mui/icons-material/DynamicFeed";
import ContactsIcon from "@mui/icons-material/Contacts";
import ElevatorIcon from '@mui/icons-material/Elevator';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';

// Map icon name string from API to React component
const iconMap = {
  DashboardIcon: <DashboardIcon />,
  WorkHistoryIcon: <WorkHistoryIcon />,
  ContactsIcon: <ContactsIcon />,
  SearchIcon: <SearchIcon />,
  CreateIcon: <CreateIcon />,
  FileUploadIcon: <FileUploadIcon />,
  DynamicFeedIcon: <DynamicFeedIcon />,
  FeedIcon: <FeedIcon />,
  ElevatorIcon: <ElevatorIcon />,
  NoteAddIcon: <NoteAddIcon />,
  ManageSearchIcon: <ManageSearchIcon />,
  PsychologyAltIcon: <PsychologyAltIcon />,
};

/**
 * Recursively replaces icon keys in menu with actual icon components
 */
function mapIcons(pages) {
  return pages.map((page) => {
    const newPage = { ...page };
    if (newPage.icon && typeof newPage.icon === "string") {
      // Use mapped icon if exists, otherwise fallback to DashboardIcon as default
      newPage.icon = iconMap[newPage.icon] || <DashboardIcon />;
    }
    if (newPage.subMenu && Array.isArray(newPage.subMenu)) {
      newPage.subMenu = mapIcons(newPage.subMenu);
    }
    return newPage;
  });
}

/**
 * Fetches menu pages from backend and maps icons to React components
 */
export async function getNavbarPages() {
  try {
    const response = await fetch(`${constants.domain}/rafa/portal/api/common/navbar`);
    if (!response.ok) throw new Error("Failed to fetch menu");
    const pages = await response.json();

    // Map icon keys to React components
    return mapIcons(pages);
  } catch (error) {
    console.error("Error fetching navbar pages:", error);
    return [];
  }
}
